import FormTbzt from '../sub-pages/form-tbzt';

export default[
    {
        show(row,extra){
            return(
                row.tbzt==='0'|| !row.tbzt
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '未同步';
        }
    },{
        show(row,extra){
            return(
                row.tbzt==='1'&& row.shbj == '9'&&row.by5!=='1'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '待平台审核';
        }
    },{
        show(row,extra){
            return(
                row.tbzt==='2'||row.tbzt==='1'
            )
        },
        tag:'my-tag',
        type:'info',
        text(row){
            return '点击查看审核结果';
        },
        click(row,extra){
            this.dialogOpen(FormTbzt,'查看审核单位')
        }
    },{
        show(row,extra){
            return(
                row.tbzt==='9'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '已发布,点击查看审核结果';
        },
        click(row,extra){
            this.dialogOpen(FormTbzt,'查看审核单位')
        }
    },{
        show(row,extra){
            return(
                row.tbzt==='3'
            )
        },
        tag:'my-tag',
        type:'danger',
        text(row){
            return '退回';
        }
    },{
        show(row,extra){
            return(
                row.tbzt==='6'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '待交易中心审核';
        }
    },
]